<template>
  <ax-dialog 
    ref="dialog"
    title="Nearby Wells" 
    subtitle="Select wells within specified radius"
    icon="mdi-map-marker-radius-outline" 
    size="small" 
    :disabled="disabled"
    @submitted="onSubmit"
  >
    <template slot="content">
      <v-card-text style="overflow:hidden">
        <span class="display-3 font-weight-light" v-text="radius"></span>
        <span class="subheading font-weight-light ml-1">{{ units.options.find(u => u.value == units.selected).text }}</span>
        <v-slider v-model="radius" :min="min" :max="max" />
        <v-radio-group v-model="units.selected" row>
          <v-radio v-for="unit in units.options" :key="unit.value" :label="unit.text" :value="unit.value" />
        </v-radio-group>
      </v-card-text>
    </template>
  </ax-dialog>
</template>
<script>
import AxDialog from '@/components/dialog'
export default {
  name: "dlgNearbyWells",
  props: {
    disabled: { type: Boolean, default: false }
  },
  components: { AxDialog },
  data() {
    return {
      units: {
        selected: 'M',
        options: [
          { text: 'Miles', value: 'M' },
          { text: 'Kilometers', value: 'K' },
          // { text: 'Nautical Miles', value: 'N' },
        ]
      },
      radius: 1,
      min: 1, 
      max: 10
    }
  },
  methods: {
    onSubmit() {
      this.$refs.dialog.show = false
      this.$emit('submitted', { radius: this.radius, units: this.units.selected })
    }
  }
}
</script>